import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import './SalesForHour.scss';
import { Paper, Typography, LinearProgress, Grid } from '@material-ui/core';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { MoneyLessBRL, MoneyFullBRL } from '../../../../services';
import { QUERY_FILTER_BOOKSTORE, QueryFilter } from 'src/component/shared';
import { GetCacheIfExists, SetDataToSession, HasNoFilterAppliedBookstore } from '../../../shared/cache/Cache';

// tslint:disable-next-line:no-empty-interface
export interface ISalesForHourProps {

}

// tslint:disable-next-line:no-empty-interface
export interface ISalesForHourState {
    dialogOpen: boolean,
    customFilter: {
        isChart: boolean
    },
    isUpdate: false,

}

export interface ISalesForHourDataChart {
    avg_price: string;
    avg_ticket: string;
    billing: number;
    billing_label?: string;
    hour: string;
    qtd_coupon: number;
    qtd_item_coupon: number;
    volume: number;
    week_day: string;
    week_day_number: number;

}

const BOOKSTORE_SALES_FOR_HOUR = gql`
query bookstoreSalesForHour($customFilter: BookstoreCustomFilter) {
    bookstoreSalesForHour(bookstoreCustomFilter: $customFilter) {
		billing,
		volume,
		avg_price,
		qtd_coupon,
		avg_ticket,
		qtd_item_coupon,
		week_day,
		week_day_number,
		hour
  }
}
`;

// statless component
const SalesForHourDataChart = ({ data }: { data: ISalesForHourDataChart[] }) => (

    <div>
    <ResponsiveContainer width="100%" height={300} >
        <BarChart
                data={data}
                layout="vertical">
                <CartesianGrid vertical={false} horizontal={false} />
                <XAxis type="number" hide={true}/>
                <YAxis yAxisId="center" type="category" dataKey="hour" interval={0}  tick={{fontSize: '65%'}}/>
                <Tooltip content={<SalesForHourTooltipData />} />
                <Bar yAxisId="center" dataKey="billing" fill="#65cc93" barSize={25} isAnimationActive={false} />
            </BarChart>
    </ResponsiveContainer>
    </div>

);

// statless component
const SalesForHourTooltipData = (props: any) => {

    let content;
    props.payload !== null &&  props.payload.length !== undefined && props.payload.length > 0 ? content = props.payload[0].payload : content = undefined;

    return (<div className="tooltip-box">
        <table>
            <tbody>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Dia:</td><td className="tooltip-content">{content && content.week_day}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Hora:</td><td className="tooltip-content">{content && content.hour + 'h'}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Faturamento:</td><td className="tooltip-content">{content && content.billing_label}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Volume: </td><td className="tooltip-content">{content && content.volume}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Preço Médio:</td><td className="tooltip-content">{content && content.avg_price}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Qtd Cupons:</td><td className="tooltip-content">{content && content.qtd_coupon}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Ticket Médio:</td><td className="tooltip-content">{content && content.avg_ticket}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Itens por Cupom:</td><td className="tooltip-content">{content && content.qtd_item_coupon}</td>
                </tr>
            </tbody>
        </table>
    </div>
    )
};

const dataFilled = (data: any) => {
    return data && data.bookstoreSalesForHour &&
        data.bookstoreSalesForHour.some((saleData: any) => !!saleData[7].qtd_coupon)
            
}

export class SalesForHour extends React.Component<ISalesForHourProps, ISalesForHourState> {
    constructor(props: ISalesForHourProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
            dialogOpen: false,
            isUpdate: false,
        }
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
                "limit": 1,
            }
        };

        return (
            <Query query={QUERY_FILTER_BOOKSTORE} notifyOnNetworkStatusChange={true}>
                {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {

                    let dataCache = GetCacheIfExists('bookstore-data');
                    const hasNoFilterAppliedBookstore = HasNoFilterAppliedBookstore(clientC);

                    if( hasNoFilterAppliedBookstore && dataCache != null && dataCache.bookstoreSalesForHour != null ) {
                        return this.dataToRend(dataCache, false);
                    } else {
                        return (
                            <Query query={BOOKSTORE_SALES_FOR_HOUR} variables={QueryFilter.getFilterBookstore(clientC, jsonFilter, [])}>
                                {({ loading, error, data, client }) => {

                                    if ( hasNoFilterAppliedBookstore && data != null && data.bookstoreSalesForHour != null ) {
                                        if(dataCache != null && dataCache !== undefined) {
                                            dataCache.bookstoreSalesForHour = data.bookstoreSalesForHour;
                                        } else {
                                            dataCache = data;
                                        }
                                        SetDataToSession('bookstore-data', dataCache);
                                    }

                                    return this.dataToRend(data, loading);
                                }}
                            </Query>
                        );
                    }
                }}
            </Query>
        )
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any) {
        return (
            <Paper className="publisher-sale-block panel-block" >
                <Typography variant="headline" className="panel-title" component="title">
                    VENDAS POR HORA DOS ÚLTIMOS 30 DIAS
                </Typography>
                {
                    loading
                    ?
                    <LinearProgress />
                    :
                    (
                        dataFilled(data)
                        ?
                        (<Grid container={true}>
                            {this.SalesForHourComponentMap(data.bookstoreSalesForHour)}
                        </Grid>)
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        )
    }

    private SalesForHourComponentMap = (bookstoreSalesForHour: any) => {
        return bookstoreSalesForHour.map( (item:any, index:number) =>
            (<Grid item={true} md={1} className="flex-hour-grid" key={index + 'grid'}>
                <Typography variant={"body2"} align="right" key={index + 'type'}>
                    {index === 0 ? "Domingo": ""}
                    {index === 1 ? "Segunda": ""}
                    {index === 2 ? "Terça": ""}
                    {index === 3 ? "Quarta": ""}
                    {index === 4 ? "Quinta": ""}
                    {index === 5 ? "Sexta": ""}
                    {index === 6 ? "Sábado": ""}
                </Typography>
                <SalesForHourDataChart data={this.SalesForHourDataChartMap(item)} key={index + 'sales'} />
            </Grid>)
        )
    }

    private SalesForHourDataChartMap = (data: ISalesForHourDataChart[]) => {
        const mappedData: ISalesForHourDataChart[] = [];
        const mappedDataForComplete: ISalesForHourDataChart[] = [];

        for (let index = 9; index < 24; index++) {

            const position = this.havingHour(data, index);
            if (position != null){
                mappedDataForComplete.push(position);
            }else{
                const itemWithZero: ISalesForHourDataChart = {
                    avg_price: '',
                    avg_ticket: '',
                    billing:  0,
                    billing_label: '',
                    hour: index.toString(),
                    qtd_coupon: 0,
                    qtd_item_coupon: 0,
                    volume: 0,
                    week_day: index === 0 ? "Domingo" : index === 1 ? "Segunda" : index === 1 ? "Terça" :
                     index === 1 ? "Quarta" : index === 1 ? "Quinta" : index === 1 ? "Sexta" :
                      index === 1 ? "Sábado" : '',
                    week_day_number: index,
                };
                mappedDataForComplete.push(itemWithZero);
            }
        }

        mappedDataForComplete.forEach(e => {
            if (e){
                const item: ISalesForHourDataChart = {
                    avg_price: e.avg_price,
                    avg_ticket: MoneyFullBRL(e.avg_ticket),
                    billing:  Number.parseFloat(e.billing.toString()),
                    billing_label: MoneyLessBRL(e.billing.toString()),
                    hour: e.hour,
                    qtd_coupon: e.qtd_coupon,
                    qtd_item_coupon: e.qtd_item_coupon,
                    volume: e.volume,
                    week_day: e.week_day,
                    week_day_number: e.week_day_number,
                };

                mappedData.push(item);
            }
        });

        return mappedData;
    }

    private havingHour = (data: ISalesForHourDataChart[], index: number) => {
        let have = null;
        data.forEach(e => {
            if (e.hour === index.toString()){
                have = e;
                return;
            }
        });

        return have;
    }
}



// WEBPACK FOOTER //
// ./src/component/bookstore/sale/sales-for-hour/SalesForHour.tsx